import qs from 'qs';
import { newAPI } from 'services';

export const fetchProduct = async (userId, establishmentId, storageProductUuid) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/storage/products/${storageProductUuid}`);
  return response.data;
}

export const createProduct = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/storage/products/to-sell-and-use/basic-information`, qs.stringify(params));
  return response.data;
}

export const updateProduct = async (userId, establishmentId, storageProductUuid, params) => {
  const response = await newAPI.patch(`${userId}/establishment/${establishmentId}/storage/products/to-sell-and-use/basic-information/${storageProductUuid}`, qs.stringify(params));
  return response.data;
}

export const updateProductIdentifiers = async (userId, establishmentId, storageProductUuid, params) => {
  const response = await newAPI.patch(`${userId}/establishment/${establishmentId}/storage/products/identifiers/${storageProductUuid}`, qs.stringify(params));
  return response.data;
}

export const fetchSupplier = async (userId, establishmentId, supplierUuid) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/storage/suppliers/${supplierUuid}`);
  return response.data;
}

export const fetchSupplierList = async (userId, establishmentId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/storage/suppliers`);
  return response.data;
}

export const createSupplier = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/storage/suppliers`, qs.stringify(params));
  return response.data;
}

export const updateSupplier = async (userId, establishmentId, supplierUuid, params) => {
  const response = await newAPI.patch(`${userId}/establishment/${establishmentId}/storage/suppliers/${supplierUuid}`, qs.stringify(params));
  return response.data;
}

export const fetchServiceProduct = async (userId, establishmentId, storageProductUuid) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/services/products/${storageProductUuid}`);
  return response.data;
}

export const createServiceProduct = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/services/products`, qs.stringify(params));
  return response.data;
}

export const updateServiceProduct = async (userId, establishmentId, serviceProductId, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/services/products/${serviceProductId}`, qs.stringify(params));
  return response.data;
}

export const removeServiceProduct = async (userId, establishmentId, serviceProductId) => {
  const response = await newAPI.delete(`${userId}/establishment/${establishmentId}/services/products/${serviceProductId}`);
  return response.data;
}

export const fetchProvisionalReceiptConfig = async (userId, establishmentId, productUuid) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/storage/product-nfe/${productUuid}`);
  return response.data;
}

export const createProvisionalReceiptConfig = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/storage/product-nfe`, qs.stringify(params));
  return response.data;
}

export const updateProvisionalReceiptConfig = async (userId, establishmentId, productUuid, params) => {
  const response = await newAPI.patch(`${userId}/establishment/${establishmentId}/storage/product-nfe/${productUuid}`, qs.stringify(params));
  return response.data;
}